import axios, { AxiosResponse } from "axios";
import { AxiosAPI } from "./api";

export const DataCollectionApi = {
  getCountries() {
    return AxiosAPI.get(`/masters-api/Country/GetCountries`)
      .then((response: any) => response.data)
      .catch((error: any) => error);
  },
  getOcrToken() {
    return AxiosAPI.get("/masters-api/Logger/GetOcrToken")
      .then((response: AxiosResponse) => response.data)
      .catch((error: any) => {
        if (error.response?.data?.errorMessage) {
          throw new Error(error.response.data.errorMessage);
        }
        throw error;
      });
  },
  extractDataFromDocument(token: string, data: any) {
	return axios.post('https://n8n.qualitasfunds.com/webhook/idDocumentOCR', { documentURL: data }, {
	  headers: {
		Authorization: `Bearer ${token}`,
	  },
	})
	  .then((response: AxiosResponse) => {
		if (response.status !== 200) {
		  throw new Error("Error");
		}
		return response.data;
	  })
	  .catch((error: any) => {
		if (error.response?.data?.errorMessage) {
		  throw new Error(error.response.data.errorMessage);
		}
		throw error;
	  });
  },
  uploadTemporaryFile(file: File) {
	const formData = new FormData();
	formData.append("file", file);
	formData.append("folder", "investor-documents");

	return AxiosAPI.post("/documentsystem-api/Documents/UploadTemporaryFile", formData, {
	  headers: {
		"Content-Type": "multipart/form-data",
	  },
	})
	  .then((response: AxiosResponse) => response.data)
	  .catch((error: any) => {
		if (error.response?.data?.errorMessage) {
		  throw new Error(error.response.data.errorMessage);
		}
		throw error;
	  });
  },
  getInstitutionsLinkedToContact() {
	return AxiosAPI.get(`/investorportal-api/DataCollection/GetInstitutionsLinkedToContact`)
	  .then((response: AxiosResponse) => response.data)
	  .catch((error: any) => {
		if (error.response?.data?.errorMessage) {
		  throw new Error(error.response.data.errorMessage);
		}
		throw error;
	  });
  },
  savePhysicalPersonData(data: any) {
	return AxiosAPI.post(`/investorportal-api/DataCollection/SavePhysicalPersonData`, data)
	  .then((response: AxiosResponse) => response.data)
	  .catch((error: any) => {
		if (error.response?.data?.errorMessage) {
		  throw new Error(error.response.data.errorMessage);
		}
		throw error;
	  });
  },
  saveLegalEntityData(data: any) {
	return AxiosAPI.post(`/investorportal-api/DataCollection/SaveLegalEntityData`, data)
	  .then((response: AxiosResponse) => response.data)
	  .catch((error: any) => {
		if (error.response?.data?.errorMessage) {
		  throw new Error(error.response.data.errorMessage);
		}
		throw error;
	  });
  }
};
